import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { css, keyframes } from "styled-components";
import { danger40, confirmation40, warning40, white, grey3, grey15, grey30, grey40, spacing4, spacing8, spacing32, spacing64, fontSize16, text120, lineHeight, sans } from "@churchofjesuschrist/eden-style-constants";
import { AlertFilled, AlertWarningFilled, CircleSelectedFilled } from "@churchofjesuschrist/eden-icons";
export const backgroundImageHelper = icon => `url("data:image/svg+xml; utf8, ${encodeURIComponent(renderToStaticMarkup(icon))}")`;
const errorBackground = backgroundImageHelper( /*#__PURE__*/React.createElement(AlertFilled, {
  color: danger40,
  size: "1.5rem"
}));
const warningBackground = backgroundImageHelper( /*#__PURE__*/React.createElement(AlertWarningFilled, {
  color: warning40,
  size: "1.5rem"
}));
const successBackground = backgroundImageHelper( /*#__PURE__*/React.createElement(CircleSelectedFilled, {
  color: confirmation40,
  size: "1.5rem"
}));
export const valuesByValidityState = {
  error: {
    color: danger40,
    background: errorBackground,
    animation: keyframes(["to{background-image:", ";}"], errorBackground)
  },
  warning: {
    color: grey30,
    background: warningBackground,
    animation: keyframes(["to{background-image:", ";}"], warningBackground)
  },
  success: {
    color: grey30,
    background: successBackground,
    animation: keyframes(["to{background-image:", ";}"], successBackground)
  }
};
export const internalUseOnlyOpenDetailsStyles = _ref => {
  let {
    Icon,
    small = false
  } = _ref;
  const useSmallOpenDetailsIcon = small;
  const animationByValidityState = {
    error: {
      animation: keyframes(["to{background-image:", ",", ";}"], valuesByValidityState.error.background, backgroundImageHelper( /*#__PURE__*/React.createElement(Icon, null)))
    },
    warning: {
      animation: keyframes(["to{background-image:", ",", ";}"], valuesByValidityState.warning.background, backgroundImageHelper( /*#__PURE__*/React.createElement(Icon, null)))
    },
    success: {
      animation: keyframes(["to{background-image:", ",", ";}"], valuesByValidityState.success.background, backgroundImageHelper( /*#__PURE__*/React.createElement(Icon, null)))
    }
  };
  return css(["", ";"], _ref2 => {
    let {
      validityState
    } = _ref2;
    const {
      background
    } = valuesByValidityState[validityState] || {};
    const {
      animation
    } = animationByValidityState[validityState] || {};
    return css(["background-image:", " ", ";padding-right:", ";background-position:", " right ", " center;background-size:", " ", ";&:-webkit-autofill{animation-name:", ";animation-fill-mode:both;animation-duration:0.00001ms;}"], background ? `${background},` : "", backgroundImageHelper( /*#__PURE__*/React.createElement(Icon, null)), background ? spacing64 : spacing32, background ? `right ${spacing32} center,` : "", spacing8, background ? "1.5rem 1.5rem," : "", useSmallOpenDetailsIcon ? "1rem 1rem" : "1.5rem 1.5rem", animation);
  });
};
const sharedCss = css(["color:", ";background-color:", ";border-radius:2px;font-size:", ";font-family:", ";line-height:", ";padding:", ";width:100%;min-width:0;background-repeat:no-repeat;background-size:1.5rem 1.5rem;", ";", ";&::placeholder{color:", ";}&:disabled{background-color:", ";color:", ";resize:none;}&:not(:where(select,:disabled)):read-only{border:none;resize:none;}"], text120, white, fontSize16, sans, lineHeight, spacing8, _ref3 => {
  let {
    validityState,
    small
  } = _ref3;
  const {
    color,
    background,
    animation
  } = valuesByValidityState[validityState] || {};
  return css(["background-position:right ", " top ", ";background-image:", ";padding-right:", ";border:1px solid ", ";&:-webkit-autofill{animation-name:", ";animation-fill-mode:both;animation-duration:0.00001ms;}"], small ? spacing4 : spacing8, small ? spacing4 : spacing8, background || "", background ? "2.5rem" : spacing8, color || grey30, animation);
}, _ref4 => {
  let {
    small
  } = _ref4;
  return small ? `height: ${spacing32};` : "height: 2.5rem;";
}, grey15, grey3, grey40);
export default sharedCss;